// reelcore.js - JavaScript controller for ReelCore video enlarger and slider
// Modular design for single instance or multiple (e.g., sliders/stories)

let reelSliderPlayers = [];
window.reelSliderPlayers = reelSliderPlayers;
let reelSliderIds = [];
let reelCurrentIndex = -1;

window.ReelCore = (function() {
	function initEnlarger(sectionId, settings) {
		const { enableWiggle = true, wiggleInterval = 7, slideInDelay = 2, enableLoop = false } = settings || {};

		if (typeof videojs === 'undefined') {
			setTimeout(() => initEnlarger(sectionId, settings), 100);
			return;
		}

		const enlarger = document.getElementById('reelEnlarger-' + sectionId);
		if (!enlarger) {
			return;
		}

		const displayMode = enlarger.dataset.displayMode || 'widget';
		const thumbnailShape = enlarger.dataset.thumbnailShape || 'rectangle';
		const position = enlarger.dataset.position || 'right';
		const thumbnail = enlarger.querySelector('.reel-enlarger__thumbnail');
		const thumbnailVideo = enlarger.querySelector('.reel-enlarger__thumbnail-video');
		const fallbackImage = enlarger.querySelector('.reel-enlarger__thumbnail-fallback-image');
		const thumbnailImage = enlarger.querySelector('.reel-enlarger__thumbnail-image');
		const overlay = enlarger.querySelector('.reel-enlarger__overlay');
		const player = enlarger.querySelector('.reel-enlarger__player');
		const video = videojs(
		'video-' + sectionId,
		{
			fluid: false,
			width: 0,
			height: parseInt(player.dataset.desktopHeight || 600),
		},
		function() {
			this.off('click');

			// 🔒 Disable default pause-on-click
			const nativeVideo = this.el().querySelector('video');
			if (nativeVideo) {
			nativeVideo.style.pointerEvents = 'none';
			}

			this.on('webkitendfullscreen', function() {
			this.play().catch(() => {
				this.muted(true);
				this.play();
			});
			});

			this.on('ended', function() {
			if (enableLoop) {
				this.currentTime(0);
				this.play().catch(() => {
				this.muted(true);
				this.play();
				});
			} else {
				minimizeVideo();
			}
			});

			const progressBarFill = enlarger.querySelector('.reel-enlarger__progress-bar-fill');
			this.on('timeupdate', function() {
			const duration = this.duration();
			const currentTime = this.currentTime();
			if (duration > 0) {
				const progressPercent = (currentTime / duration) * 100;
				progressBarFill.style.width = progressPercent + '%';
			}
			});
		}
		);

		const playerAspectRatio = 9 / 16; // Always 9:16 for player
		const thumbnailAspectRatio = thumbnailShape === 'circle' ? 1 : 9 / 16;

		function adjustThumbnailSize() {
			const height = window.innerWidth <= 767 ? parseInt(thumbnail.dataset.mobileHeight || 180) : parseInt(thumbnail.dataset.desktopHeight || 250);
			const width = height * thumbnailAspectRatio;
			thumbnail.style.width = width + 'px';
			thumbnail.style.height = height + 'px';

			if (thumbnailVideo) {
				thumbnailVideo.style.display = 'block';
				if (fallbackImage) fallbackImage.style.display = 'none';
			} else if (thumbnailImage) {
				thumbnailImage.style.width = '100%';
				thumbnailImage.style.height = '100%';
			}

			if (thumbnailVideo) {
				thumbnailVideo.addEventListener(
					'error',
					() => {
						if (fallbackImage) {
							fallbackImage.style.display = 'block';
							thumbnailVideo.style.display = 'none';
						}
					},
					{ once: true }
				);
			}
		}

		function forceVideoRepaint() {
			if (thumbnailVideo) {
				thumbnailVideo.style.visibility = 'hidden';
				void thumbnailVideo.offsetWidth;
				thumbnailVideo.style.visibility = 'visible';
				thumbnailVideo.play().catch(() => {});
			}
		}

		function minimizeVideo() {
			video.pause();
			player.style.display = 'none';
			player.classList.remove('active');
			thumbnail.style.display = 'flex';
			adjustThumbnailSize();
			if (thumbnailVideo) {
				thumbnailVideo.play().catch(() => {});
			}
			if (displayMode === 'popup') {
				overlay.style.display = 'none';
			}
		}

		setTimeout(() => {
			thumbnail.style.display = 'flex';
			adjustThumbnailSize();
			thumbnail.classList.add('active');
			if (thumbnailVideo) {
				thumbnailVideo.play().catch(() => {
					thumbnailVideo.muted = true;
					thumbnailVideo.play();
				});
			}

			if (enableWiggle) {
				const intervalMs = wiggleInterval * 1000;
				let wiggleTimer = setInterval(() => {
					if (!thumbnail.classList.contains('active')) {
						clearInterval(wiggleTimer);
						return;
					}
					thumbnail.classList.remove('wiggling');
					void thumbnail.offsetWidth;
					thumbnail.classList.add('wiggling');
				}, intervalMs);
				thumbnail.classList.add('wiggling');
			}
		}, slideInDelay * 1000);

		thumbnail.addEventListener('click', (e) => {
			// If the close button inside the thumbnail was clicked
			if (e.target.closest('.reel-enlarger__close')) {
				thumbnail.style.display = 'none';
				return; // Don't continue to enlarger logic
			}

			// 👇 Proceed with enlarger logic
			if (thumbnailVideo) thumbnailVideo.pause();
			thumbnail.style.display = 'none';
			player.style.display = 'block';
			player.classList.add('active');

			// Mute all slider videos if any are active
			if (window.reelSliderPlayers && Array.isArray(window.reelSliderPlayers)) {
				reelSliderPlayers.forEach((p, i) => {
					p.muted(true);
					const sliderItems = document.querySelectorAll('.reel-slider-item');
					if (sliderItems[i]) {
						sliderItems[i].classList.remove('unmuted');
					}
				});
			}

			video.currentTime(0); // Reset video to the beginning
			adjustVideoSize();

			if (displayMode === 'popup') {
				overlay.style.display = 'block';
			}

			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						video.play().catch(() => {
							video.muted(true);
							video.play();
						});
						observer.unobserve(entry.target);
					}
				});
			}, { threshold: 0.5 });

			observer.observe(player);
		});

		const closeBtn = enlarger.querySelector('.reel-enlarger__close');
		if (displayMode === 'popup' && overlay) {
		overlay.addEventListener('click', function(e) {
			if (e.target === overlay) {
			video.pause();
			overlay.style.display = 'none';
			thumbnail.style.display = 'flex';
			player.style.display = 'none';
			player.classList.remove('active');
			}
		});
		}

		const minimizeBtn = enlarger.querySelector('.reel-enlarger__minimize');
		minimizeBtn.addEventListener('click', minimizeVideo);

		function adjustVideoSize() {
			let targetHeight, targetWidth;
			const isMobile = window.innerWidth <= 767;
			const baseMaxHeight = isMobile ? parseInt(player.dataset.mobileHeight || 440) : parseInt(player.dataset.desktopHeight || 600);

			if (displayMode === 'popup') {
				const viewportMaxHeight = window.innerHeight * 0.9;
				const viewportMaxWidth = window.innerWidth * 0.9;
				targetHeight = Math.min(viewportMaxHeight, baseMaxHeight);
				targetWidth = targetHeight * playerAspectRatio;
				if (targetWidth > viewportMaxWidth) {
					targetWidth = viewportMaxWidth;
					targetHeight = targetWidth / playerAspectRatio;
				}
			} else {
				targetHeight = baseMaxHeight;
				if (isMobile) {
					targetHeight = Math.min(targetHeight, 440);
				}
				targetWidth = targetHeight * playerAspectRatio;
				if (!isMobile) {
					const maxWidth = window.innerWidth * 0.8;
					if (targetWidth > maxWidth) {
						targetWidth = maxWidth;
						targetHeight = targetWidth / playerAspectRatio;
					}
				}
			}

			video.width(targetWidth);
			video.height(targetHeight);
			player.style.width = targetWidth + 'px';
			player.style.height = targetHeight + 'px';
			enlarger.querySelector('.reel-enlarger__video').style.width = targetWidth + 'px';
			enlarger.querySelector('.reel-enlarger__video').style.height = targetHeight + 'px';
		}

		function adjustHeights() {
			adjustThumbnailSize();
			if (player.classList.contains('active')) {
				adjustVideoSize();
			}
			forceVideoRepaint();
		}

		// Apply initial positioning based on settings
		enlarger.style.bottom = player.dataset.bottomPadding || '10px';
		if (position === 'left') {
			enlarger.style.left = player.dataset.sidePadding || '10px';
			enlarger.style.right = 'auto';
		} else {
			enlarger.style.right = player.dataset.sidePadding || '10px';
			enlarger.style.left = 'auto';
		}

		window.addEventListener('resize', adjustHeights);
		adjustHeights();
	}

	function initSlider(sectionId) {
		const section = document.getElementById(`reelSlider-${sectionId}`);
		if (!section) return;

		let isOnSlowConnection = false;

		// Detect slow cellular connections
		if ('connection' in navigator) {
			const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
			if (conn) {
				const isCellular = conn.type === 'cellular';
				const isNot5G = conn.effectiveType !== '5g';
				const isLowDownlink = conn.downlink && conn.downlink < 3;
				const isHighLatency = conn.rtt && conn.rtt > 300;
				const isDataSaver = conn.saveData === true;

				isOnSlowConnection = isCellular && (isNot5G || isLowDownlink || isHighLatency || isDataSaver);
			}
		}

		const autoplayEnabled = section.dataset.autoplay !== 'false' && !isOnSlowConnection;
		let isMuted = section.dataset.muted === 'true';
		const sliderItems = section.querySelectorAll('.reel-slider-item');
		const videoPlayers = [];

		if (!sliderItems.length) return;

		sliderItems.forEach((item, index) => {
			const videoEl = item.querySelector('video-js');

			if (!videoEl.id) videoEl.id = `video-${sectionId}-${index}`;

			if (!reelSliderIds.includes(videoEl.id)) {
				reelSliderIds.push(videoEl.id);
			}

			const player = videojs(videoEl.id, {
				controls: false,
				autoplay: false,
				muted: isMuted,
				loop: false,
				preload: 'metadata',
				techOrder: ['html5'],
				html5: {
					nativeAudioTracks: false,
					nativeVideoTracks: false,
					hls: {
						withCredentials: false
					}
				}
			});

			videoPlayers.push(player);
			reelSliderPlayers.push(player);

			let touchStartX = 0;
			let touchStartY = 0;
			let touchMoved = false;

			item.addEventListener('touchstart', e => {
				touchStartX = e.touches[0].clientX;
				touchStartY = e.touches[0].clientY;
				touchMoved = false;
			});

			item.addEventListener('touchmove', e => {
				const dx = e.touches[0].clientX - touchStartX;
				const dy = e.touches[0].clientY - touchStartY;
				if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
					touchMoved = true;
				}
			});

			item.addEventListener('touchend', e => {
				if (!touchMoved) {
					// Treat as tap
					videoPlayers.forEach((p, i) => {
						p.pause();
						p.muted(true);
						p.currentTime(0);
						sliderItems[i].classList.remove('playing');
					});

					scrollToItem(item);
					player.muted(false);
					player.play();
					item.classList.add('playing');
					item.classList.add('unmuted');
				}
			});

			// Add mute toggle button
			const muteBtn = document.createElement('button');
			muteBtn.classList.add('mute-toggle');
			muteBtn.innerHTML = `
				<svg class="icon-mute" viewBox="0 0 24 24" stroke="white"><path d="M5 9v6h4l5 5V4l-5 5H5z"/></svg>
				<svg class="icon-unmute" viewBox="0 0 24 24" stroke="white"><path d="M9 5v14l11-7z"/></svg>
			`;
			item.appendChild(muteBtn);

			muteBtn.addEventListener('click', e => {
				e.stopPropagation();

				let isCurrentlyMuted = section.dataset.muted === 'true';
				let newMuteState = !isCurrentlyMuted;

				section.dataset.muted = newMuteState;
				if (!newMuteState) {
					muteOtherSections(sectionId);
				}

				videoPlayers.forEach(p => p.muted(newMuteState));
				updateMuteUI();
			});

			muteBtn.addEventListener('touchend', e => {
				e.stopPropagation();
				e.preventDefault();

				let isCurrentlyMuted = section.dataset.muted === 'true';
				let newMuteState = !isCurrentlyMuted;

				section.dataset.muted = newMuteState;
				if (!newMuteState) {
					muteOtherSections(sectionId);
				}

				videoPlayers.forEach(p => p.muted(newMuteState));
				updateMuteUI();
			});

			function updateMuteUI() {
				const isSectionMuted = section.dataset.muted === 'true';
				sliderItems.forEach((el) => {
					el.classList.toggle('unmuted', !isSectionMuted);
				});
			}

			item.addEventListener('click', () => {
				videoPlayers.forEach((p, i) => {
					p.pause();
					p.muted(true);
					sliderItems[i].classList.remove('playing');
				});

				scrollToItem(item);
				
				player.currentTime(0);

				isMuted = false; // user-initiated = assume intent to hear sound
				section.dataset.muted = 'false';
				muteOtherSections(sectionId);
				player.muted(false); // unmute selected video
				player.play();

				item.classList.add('playing');
				updateMuteUI();
			});

			const enlargeBtn = item.querySelector('.enlarger-toggle');
			if (enlargeBtn) {
			const handleEnlargerOpen = (e) => {
				e.stopPropagation();
				e.preventDefault(); // Prevent default to avoid tap delays on iOS

				// Pause all slider videos
				videoPlayers.forEach(p => p.pause());

				// Unmute intent
				isMuted = false;
				section.dataset.muted = 'false';
				muteOtherSections(sectionId);
				videoPlayers.forEach(p => p.muted(isMuted));
				updateMuteUI();

				const localItems = section.querySelectorAll('.reel-slider-item');
				const localIds = [];

				localItems.forEach((item, i) => {
				const vid = item.querySelector('video-js');
				if (vid && vid.id) {
					localIds.push(vid.id);
				}
				});

				const idx = localIds.indexOf(videoEl.id);
				if (idx !== -1) {
				launchPopupEnlarger(idx, sectionId);
				}
			};

			enlargeBtn.addEventListener('click', handleEnlargerOpen);
			enlargeBtn.addEventListener('touchend', handleEnlargerOpen);
			}

			player.on('ended', () => {
				player.pause();
				player.currentTime(0);
				item.classList.remove('playing');

				if (!autoplayEnabled) return;

				const nextIndex = index + 1 < videoPlayers.length ? index + 1 : 0;
				const nextItem = sliderItems[nextIndex];

				scrollToItem(nextItem);

				setTimeout(() => {
					const section = document.getElementById(`reelSlider-${sectionId}`);
					const sectionMuted = section?.dataset.muted === 'true';

					videoPlayers[nextIndex].muted(sectionMuted);
					videoPlayers[nextIndex].currentTime(0);
					videoPlayers[nextIndex].play();
					highlightPlayingItem(sliderItems, videoPlayers, nextIndex);

					// 🔧 Force mute icon update for this section only
					sliderItems.forEach((el, i) => {
						el.classList.toggle('unmuted', !sectionMuted && i === nextIndex);
					});
				}, 300);
			});

			player.on('timeupdate', () => {
				const progressFill = item.querySelector('.progress-bar-fill');
				const duration = player.duration();
				const current = player.currentTime();
				if (duration && progressFill) {
					progressFill.style.width = `${(current / duration) * 100}%`;
				}
			});
		});

		function scrollToItem(item) {
			const container = item.closest('.reel-slider-container');
			if (!container) return;

			const itemLeft = item.offsetLeft;
			const itemWidth = item.offsetWidth;
			const containerScrollLeft = container.scrollLeft;
			const containerWidth = container.offsetWidth;

			const itemCenter = itemLeft + itemWidth / 2;
			const containerCenter = containerScrollLeft + containerWidth / 2;

			const scrollTo = containerScrollLeft + (itemCenter - containerCenter);

			container.scrollTo({
				left: scrollTo,
				behavior: 'smooth'
			});
		}

		function highlightPlayingItem(items, players, activeIndex) {
			items.forEach((el, i) => {
				if (i === activeIndex) {
					el.classList.add('playing');
				} else {
					el.classList.remove('playing');
					players[i].pause();
				}
			});
		}

		function launchPopupEnlarger(index, sectionId, resetToStart = false) {

			const existing = document.querySelector('.reel-popup-overlay');
			if (existing) existing.remove();

			const section = document.getElementById(`reelSlider-${sectionId}`);
			if (!section) return;

			const localItems = section.querySelectorAll('.reel-slider-item');
			const localPlayers = [];
			const localIds = [];

			localItems.forEach((item, i) => {
				const vid = item.querySelector('video-js');
				if (!vid || !vid.id) return;

				const matchingIndex = reelSliderIds.indexOf(vid.id);
				if (matchingIndex !== -1) {
					localPlayers.push(reelSliderPlayers[matchingIndex]);
					localIds.push(vid.id);
				}
			});

			if (!localPlayers.length || index >= localPlayers.length) return;

			const srcPlayer = localPlayers[index];
			const currentTime = srcPlayer.currentTime();
			const currentId = localIds[index];
			const originalEl = document.getElementById(currentId);

			if (!originalEl) {
				return;
			}

			// Create overlay and container
			const overlay = document.createElement('div');
			overlay.className = 'reel-popup-overlay';

			const container = document.createElement('div');
			container.className = 'reel-popup-player';

			// Left nav button
			const navLeft = document.createElement('button');
			navLeft.className = 'popup-nav popup-nav-left';
			navLeft.innerHTML = `
			<span class="popup-nav-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
				<path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/>
				</svg>
			</span>
			`;
			navLeft.addEventListener('click', (e) => {
				e.stopPropagation();
				const newIndex = (index - 1 + localPlayers.length) % localPlayers.length;

				// Update slider UI
				const sliderItems = section.querySelectorAll('.reel-slider-item');
				sliderItems.forEach((item, i) => {
					item.classList.toggle('playing', i === newIndex);
					if (i === newIndex) {
						item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
					}
				});

				overlay.remove();
				launchPopupEnlarger(newIndex, sectionId, true);
			});

			// Right nav button
			const navRight = document.createElement('button');
			navRight.className = 'popup-nav popup-nav-right';
			navRight.innerHTML = `
			<span class="popup-nav-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
				<path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/>
				</svg>
			</span>
			`;
			navRight.addEventListener('click', (e) => {
				e.stopPropagation();
				const newIndex = (index + 1) % localPlayers.length;

				// Update slider UI
				const sliderItems = section.querySelectorAll('.reel-slider-item');
				sliderItems.forEach((item, i) => {
					item.classList.toggle('playing', i === newIndex);
					if (i === newIndex) {
						item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
					}
				});

				overlay.remove();
				launchPopupEnlarger(newIndex, sectionId, true);
			});

			container.appendChild(navLeft);
			container.appendChild(navRight);

			// Build progress bar
			const progressBarWrapper = document.createElement('div');
			progressBarWrapper.className = 'popup-progress-bar';

			const progressBarFill = document.createElement('div');
			progressBarFill.className = 'popup-progress-bar-fill';

			progressBarWrapper.appendChild(progressBarFill);

			// Clone video
			const clone = originalEl.cloneNode(false);
			const source = originalEl.querySelector('source');
			if (source) {
				const newSource = source.cloneNode(true);
				clone.appendChild(newSource);
			}

			const newId = `${currentId}-popup-${Date.now()}`;
			clone.id = newId;
			clone.classList.add('video-js');

			// Size and style
			const isMobile = window.innerWidth <= 767;

			let targetWidth, targetHeight;

			if (isMobile) {
				// 70% of viewport width on mobile, height = 16:9 aspect
				targetWidth = Math.floor(window.innerWidth * 0.7);
				targetHeight = Math.floor(targetWidth * (16 / 9));
			} else {
				// 90% of viewport height on desktop, width = 9:16 aspect
				targetHeight = Math.floor(window.innerHeight * 0.9);
				targetWidth = Math.floor(targetHeight * (9 / 16));
			}

			container.style.width = `${targetWidth}px`;
			container.style.height = `${targetHeight}px`;
			clone.style.width = `${targetWidth}px`;
			clone.style.height = `${targetHeight}px`;

			// Close button
			const close = document.createElement('button');
			close.className = 'popup-close';
			close.innerHTML = `
			<svg viewBox="0 0 24 24" fill="none" stroke="#000">
				<path d="M18 6L6 18M6 6l12 12"/>
			</svg>
			`;
			close.addEventListener('click', () => {
				const popupInstance = videojs.getPlayer(newId);
				const section = document.getElementById(`reelSlider-${sectionId}`);
				const autoplayEnabled = section?.dataset.autoplay !== 'false';

				if (popupInstance) {
					const resumeTime = popupInstance.currentTime();
					popupInstance.dispose();

					if (autoplayEnabled) {
						srcPlayer.currentTime(resumeTime);
						srcPlayer.play();
						// Mark the correct slider item as playing
						const items = section.querySelectorAll('.reel-slider-item');
						items.forEach((item, i) => {
							item.classList.toggle('playing', localPlayers[i] === srcPlayer);
						});
					} else {
						// Reset the slider UI visually if autoplay is off
						const items = section.querySelectorAll('.reel-slider-item');
						items.forEach(item => {
							item.classList.remove('playing');
						});
					}
				}

				overlay.remove();
			});

			// Assemble DOM
			container.appendChild(close);
			container.appendChild(progressBarWrapper);
			container.appendChild(clone);
			overlay.appendChild(container);
			document.body.appendChild(overlay);

			// Setup player
			requestAnimationFrame(() => {
				const popupPlayer = videojs(newId, {
					controls: true,
					autoplay: false,
					muted: isMuted,
					loop: false,
					muted: isMuted,
					preload: 'metadata',
					techOrder: ['html5'],
					html5: {
						nativeAudioTracks: false,
						nativeVideoTracks: false,
						hls: {
							withCredentials: false
						}
					}
				});

				popupPlayer.ready(() => {
					popupPlayer.one('loadedmetadata', () => {
						const section = document.getElementById(`reelSlider-${sectionId}`);
						const sectionMuted = section?.dataset.muted === 'true';

						popupPlayer.muted(sectionMuted);

						if (resetToStart) {
						popupPlayer.currentTime(0);
						} else {
						popupPlayer.currentTime(currentTime);
						}

						popupPlayer.play().catch(err => {});
					});

					popupPlayer.on('timeupdate', () => {
						const duration = popupPlayer.duration();
						const current = popupPlayer.currentTime();
						if (duration > 0) {
						progressBarFill.style.width = `${(current / duration) * 100}%`;
						}
					});
				});

				popupPlayer.on('ended', () => {
					popupPlayer.dispose();
					overlay.remove();

					const nextIndex = (index + 1) % localPlayers.length;

					const scopedSliderItems = section.querySelectorAll('.reel-slider-item');
					scopedSliderItems.forEach((item, i) => {
						item.classList.toggle('playing', i === nextIndex);
					});

					launchPopupEnlarger(nextIndex, sectionId);
				});
			});

			// Allow clicking on overlay (outside video container) to close enlarger
			overlay.addEventListener('click', function(e) {
				// Close only if click target is the overlay, not the player itself
				if (e.target === overlay) {
					const popupInstance = videojs.getPlayer(newId);
					if (popupInstance) {
						const resumeTime = popupInstance.currentTime();
						popupInstance.dispose();
						srcPlayer.currentTime(resumeTime);
						srcPlayer.play();
					}
					overlay.remove();
				}
			});
		}

		function muteOtherSections(activeSectionId) {
			for (const id in window.reelSections) {
				if (id !== activeSectionId) {
				const { players, container } = window.reelSections[id];
				players.forEach(p => p.muted(true));
				container.dataset.muted = 'true';

				// Update UI
				container.querySelectorAll('.reel-slider-item').forEach(item => {
					item.classList.remove('unmuted');
				});
				}
			}
		}

		if (!window.reelSections) window.reelSections = {};
		window.reelSections[sectionId] = {
		players: videoPlayers,
		container: section
		};

		if (autoplayEnabled) {
			const observer = new IntersectionObserver(
				(entries, observerInstance) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							scrollToItem(sliderItems[0]);
							videoPlayers[0].muted(isMuted);
							videoPlayers[0].play();
							sliderItems[0].classList.add('playing');
							observerInstance.disconnect(); // Only trigger once
						}
					});
				},
				{ threshold: 0.5 }
			);
			observer.observe(section);
		}
	}

	return {
		initEnlarger,
		initSlider
	};
})();
